import { cn } from '@/lib/utils';

/**
 * Tenant logo from system configuration, or a letter tile in the brand
 * colour when no logo is set. `compact` is the square mark for the
 * collapsed rail and the mobile bar.
 */
export default function BrandMark({
    logoUrl,
    name,
    compact = false,
}: {
    logoUrl?: string | null;
    name?: string | null;
    compact?: boolean;
}) {
    const displayName = name || 'Quantix';
    if (logoUrl) {
        return (
            <img
                src={logoUrl}
                alt={displayName}
                className={cn('object-contain', compact ? 'h-7 w-7' : 'h-8 w-auto max-w-[140px]')}
            />
        );
    }
    return (
        <span
            aria-label={displayName}
            className="flex h-8 w-8 items-center justify-center rounded-md bg-primary text-base font-bold text-primary-foreground"
        >
            {displayName.charAt(0).toUpperCase()}
        </span>
    );
}
